// extracted by mini-css-extract-plugin
module.exports = {"baseFont":"Toggle__baseFont__2C1H1","toggle":"Toggle__toggle__2bnrv","baseColor":"Toggle__baseColor__39op7","baseFontFamily":"Toggle__baseFontFamily__2gs8b"};